import type { ColorKey } from '@iheartjane/reefer';
import { Flex, Tag } from '@iheartjane/reefer';
import type { SpecialType } from '@iheartjane/types';

export interface SpecialTypeCellStylesMap {
  background: ColorKey;
  color: ColorKey;
  label: string;
}

export const specialTypeStyles: Record<SpecialType, SpecialTypeCellStylesMap> =
  {
    product: {
      background: 'primary-light',
      color: 'primary-dark',
      label: 'Products',
    },
    qualified_group: {
      background: 'palm-light',
      color: 'palm-dark',
      label: 'Qualified Group',
    },
    bundle: {
      background: 'ember-light',
      color: 'ember-dark',
      label: 'Buy X Get Y',
    },
    bulk_pricing: {
      background: 'pacific-light',
      color: 'pacific-dark',
      label: 'Bulk Pricing',
    },
    cart_total: {
      background: 'seafoam-light',
      color: 'seafoam-dark',
      label: 'Cart Total',
    },
    spending_threshold: {
      background: 'gold-light',
      color: 'gold-dark',
      label: 'Spend X Get Y',
    },
  };

export const SpecialTypeCell = ({ specialType }: { specialType: string }) => {
  const { background, color, label } = specialTypeStyles[
    specialType as SpecialType
  ] || {
    background: 'grays-mid',
    color: 'grays-white',
    label: specialType,
  };

  return (
    <Flex minWidth={150}>
      <Tag background={background} color={color} label={label} />
    </Flex>
  );
};
